/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SsoToken
 */
export interface SsoToken {
    /**
     * 
     */
    token: string;
}

/**
 * Check if a given object implements the SsoToken interface.
 */
export function instanceOfSsoToken(value: object): value is SsoToken {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function SsoTokenFromJSON(json: any): SsoToken {
    return SsoTokenFromJSONTyped(json, false);
}

export function SsoTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): SsoToken {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function SsoTokenToJSON(json: any): SsoToken {
    return SsoTokenToJSONTyped(json, false);
}

export function SsoTokenToJSONTyped(value?: SsoToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

